<template>
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <div v-if="apartments" class="hidden lg:block">
            {{ $t("apartments.apartmentSelector") }}
            <Dropdown v-model="selected" :filter="true" :auto-filter-focus="true" filter-match-mode="startsWith" :options="apartments" class="minplan-apartment-switch"
                optionLabel="name" 
                :style="{ 
                    width: '240px', 
                    backgroundColor: 'rgba(0, 0, 0, 0.15)', 
                    borderColor: 'rgba(255, 255, 255, 0.2)',
                    color: $page.props.branding?.navbar_text_color || 'white'
                }" 
                @change="apartmentSwitched($event)">
                <template #value="item">
                    <div v-if="item.value" class="flex items-center">
                        <span :aria-label="item.value.state ? 'OK' : 'not OK'"
                            :class="[item.value.state ? 'bg-green-400' : 'bg-gray-200', 'flex-shrink-0 inline-block h-2 w-2 rounded-full']" />
                        <span class="ml-3 block truncate"
                            :style="{ color: $page.props.branding?.navbar_text_color || 'white' }">
                            {{ item.value.name }}
                        </span>
                    </div>
                    <div v-else class="text-white opacity-60">{{ item.placeholder }}</div>
                </template>
                <template #option="opt">
                    <div class="flex items-center">
                        <span
                            :class="[opt.option.ok ? 'bg-green-400' : 'bg-gray-200', 'flex-shrink-0 inline-block h-2 w-2 rounded-full']"
                            aria-hidden="true" />
                        <span
                            :class="[selected.name === opt.option.name ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                            {{ opt.option.name }}
                            <span class="sr-only"> is {{ opt.option.state ? "OK" : "not OK" }}</span>
                        </span>
                    </div>

                    <span v-if="selected.name === opt.option.name"
                        :class="['text-minplan-grey absolute inset-y-0 right-0 flex items-center pr-4']">
                        <CheckIcon aria-hidden="true" class="h-5 w-5" />
                    </span>
                </template>
            </Dropdown>
        </div>

    </transition>
</template>

<script>
import { CheckIcon } from "@heroicons/vue/outline";
import { Inertia } from "@inertiajs/inertia";
import { ref } from "vue";

export default {
    props: ['fetchApartmentsRoute', 'apartment', 'event', 'showApartmentRouteString'],
    emits: ['switched'],
    components: {
        CheckIcon,
    },
    async created() {
        this.removeStartEventListener = Inertia.on("success", (event) => {
            if (this.event === "refreshSelection") {
                this.loadSwitcher();
            }
        });
        await this.loadSwitcher();
    },
    setup() {
        let apartments = ref(null);
        const selected = ref(null);
        return {
            apartments,
            selected,
        };
    },
    methods: {
        async apartmentSwitched(event) {
            this.selected = event.value;
            Inertia.visit(this.route(this.showApartmentRouteString, { apartment: event.value.uuid }), {
                onSuccess: await this.$emit('switched', event.value.uuid)
            });
        },
        async loadSwitcher() {
            const ap_response = await fetch(this.fetchApartmentsRoute);
            this.apartments = await ap_response.json();
            this.selected = this.apartments.find((a) => a.uuid === this.apartment.uuid);
        },
    },
    unmounted() {
        this.removeStartEventListener();
    },
};
</script>

<style scoped></style>
